import { render, staticRenderFns } from "./productOptionEditor.vue?vue&type=template&id=0421b674&scoped=true"
import script from "./productOptionEditor.vue?vue&type=script&lang=js"
export * from "./productOptionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0421b674",
  null
  
)

export default component.exports